import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { MdfAllocationSummary } from "./types";

// Reads the partner's active allocations (fund.status='open' AND today
// inside fund period). Powers the /portal/mdf/new allocation chooser and
// gates the list page's "Request funds" button when empty.
export function useMdfAllocations() {
  return useQuery<MdfAllocationSummary[]>({
    queryKey: queryKeys.mdf.allocations(),
    queryFn: () =>
      apiFetch<MdfAllocationSummary[]>("/portal/mdf/allocations"),
  });
}
